import React from "react";

// Change get a quote picture to a block one instead of yard
// Center the title page
// Make Mobile better


const ServiceList = (props) => {
    return (
        <div class="">
            <div class="" row='row'>

                {/* This is the container for the card */}
                <div className=" col s12 m12">

                {/* Title of the block
                // It changes in each different page */}
                    <div class=" white  card medium">

                        <div class="card-title">
                            
                            <h3 class="brown-text bcenter">{props.Title}</h3>
                            
                        </div>

                        {/* This block of code in the case we want to add cards later
                        for more menus */}
                
                  
                        <div class='divider brown'></div>
                        {/* List of services 
                        Block in the middle with the list of the services*/}
                        <div class="card-content white lighten-3 brown">
             
                            <br></br>
                            <br></br>
                            
                            <div class=" service-list-font white-text" id="">{props.itemList[0]}</div>
                            <div class=" service-list-font white-text" id="">{props.itemList[1]}</div>
                            <div class=" service-list-font white-text" id="">{props.itemList[2]}</div>
                            <div class=" service-list-font white-text" id="">{props.itemList[3]}</div>
                            <div class=" service-list-font white-text" id="">{props.itemList[4]}</div>
                            <br></br>
                            <br></br>
                            <br></br>
                        
                        </div>

                    </div>
                   
                </div>
            </div>
        </div>

    )
}

export default ServiceList;
